import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerVM, ErrorMessageModel } from 'src/app/models/customer/customer.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-address-add',
  templateUrl: './customer-address-add.component.html',
  styleUrls: ['./customer-address-add.component.css']
})
export class CustomerAddressAddComponent implements OnInit {

  customerModel: CustomerVM = new CustomerVM();
  Loader: boolean = false;
  errorMessageModel: Array<ErrorMessageModel> = new Array<ErrorMessageModel>();
  errorMessages: ErrorMessageModel = new ErrorMessageModel();
  returnUrl: string;
  ProductId: number;
  IsQuote: boolean

  constructor(private _customerService: CustomerService, private modalService: NgbModal, private activatedRoute: ActivatedRoute, private localstorage: LocalstorageService, private alertify: AlertifyService, private router: Router) {
    this.localstorage.setMenu("2");
    this.activatedRoute.queryParams.subscribe((param) => {
      this.returnUrl = param.return;
    });
  }

  ngOnInit() {
    this.ProductId = this.ProductId;
  }

  CustomerAddress() {
    if (this.customerModel.AddressTitle == undefined || this.customerModel.AddressTitle == null || this.customerModel.AddressTitle == "") {
      this.alertify.error("Address is required");
      return;
    }
    if (this.customerModel.State == undefined || this.customerModel.State == null || this.customerModel.State == "") {
      this.alertify.error("State is required");
      return;
    }
    if (this.customerModel.City == undefined || this.customerModel.City == null || this.customerModel.City == "") {
      this.alertify.error("City is required");
      return;
    }
    if (this.customerModel.ZipCode == undefined || this.customerModel.ZipCode == null || this.customerModel.ZipCode == "") {
      this.alertify.error("ZipCode is required");
      return;
    }
    if (this.customerModel.PhoneNumber == undefined || this.customerModel.PhoneNumber == null || this.customerModel.PhoneNumber == "") {
      this.alertify.error("Phone Number is required");
      return;
    }
    // if (this.customerModel.Landmark == undefined || this.customerModel.Landmark == null || this.customerModel.Landmark == "") {
    //   this.alertify.error("Landmark is required");
    //   return;
    // }
    // if (this.customerModel.AddressNote == undefined || this.customerModel.AddressNote == null || this.customerModel.AddressNote == "") {
    //   this.alertify.error("AddressNote is required");
    //   return;
    // }
    if (this.customerModel.Street == undefined || this.customerModel.Street == null || this.customerModel.Street == "") {
      this.alertify.error("Street is required");
      return;
    }
    this.errorMessageModel = [];
    this.Loader = true;
    this._customerService.CustomerAddressAdd(this.customerModel).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.alertify.success(responseBody.responseMessage);
        this.Loader = false;
        if(this.ProductId) {
          this.modalService.dismissAll();
        } else {
          this.router.navigate(['/customer-address-list']);
        }
      } else {
        for(var i = 0; i < responseBody.responseData.messages.length; i++) {
          this.errorMessages = responseBody.responseData.messages[i];
          var messagesItem = new ErrorMessageModel();
          if (this.errorMessages) {
            messagesItem = this.errorMessages;
            this.errorMessageModel.push(messagesItem);
          }
          this.Loader = false;
      }
    }
    });
  }

  discardModel() {
    if(this.ProductId) {
      this.modalService.dismissAll();
      this.Loader = false;
    } else {
      this.router.navigate(['/customer-address-list']);
      this.Loader = false;
    }
  }
}
